import React, { Component } from 'react'

import '../App.css';
import './styles/Team.css';

import TeamDesktop from './Desktop/Team';
import TeamMobile from './Mobile/Team';

import firebase from '../firebase';

export default class Team extends Component {

  state = {
    members: [],
    description: "",
    isHeightSmall: false,
    isLoading: true,
  }

  componentDidMount() {
    const teamRef = firebase.database().ref('team');

    this.setState({
      isLoading: true
    })

    teamRef.once('value').then((snapshot) => {
      let teamData = snapshot.val();

      let teamMembers = teamData['members'];

      var result = [];

      for (var i in teamMembers)
        result.push(teamMembers[i]);

      this.setState({
        members: result,
        description: teamData['description'],
        isLoading: false
      });
    });


    // setup window size listener (for switching mobile to desktop)
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize = () => {

    this.setState({
      isHeightSmall: window.innerHeight <= 700
    })
  }

  render() {
    if (this.props.isMobile) {
      return (
        <TeamMobile 
          {...this.state}
          upAction = {this.props.upAction} />
      );
    } else {
      return (
        <TeamDesktop {...this.state} upAction = {this.props.upAction}/>
      );
    }
  }
}
